import { render, staticRenderFns } from "./RenewTh.vue?vue&type=template&id=6d67cdba&scoped=true&"
var script = {}
import style0 from "./RenewTh.vue?vue&type=style&index=0&id=6d67cdba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67cdba",
  null
  
)

export default component.exports